export default function Configure($stateProvider) {
	$stateProvider.state('mouvement-stock', {
		parent: 'gestion',
		url: '/mouvement-stock',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.STOCKS" | translate }}'
		}
	});

	$stateProvider.state('mouvement-stock.list', {
		url: '/list',
		template: '<mouvement-stock></mouvement-stock>',
		rights: { domain: 'stockjournalier', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS.BREADCRUMBS.MOUVEMENT_STOCK" | translate}}'
		},
		navigation: {
			menu: 'stocks_no_category',
			translate: 'STOCKS.BREADCRUMBS.MOUVEMENT_STOCK',
			order: 1
		},
		search: 'STOCKS.BREADCRUMBS.MOUVEMENT_STOCK',
		params: {
			idSociete: null,
			idRegoupementSite: null,
			idProduit: null,
			date: null
		}
	});
}

Configure.$inject = ['$stateProvider'];
